import React from "react";
import premiumBlockContext from "./premiumBlockContext";
const PremiumBlockState = props => {
    return (
        <premiumBlockContext.Provider
            value={{
                
            }}
        >
            {props.children}
        </premiumBlockContext.Provider>
    )
}
export default PremiumBlockState;